import {EmployeeGroup} from 'app/blocks/model/employee-group.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IEmployeeGroup} from 'app/blocks/model/employee-group.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class EmployeeGroupService extends EntityCrudService<IEmployeeGroup> {
    constructor(http: HttpClient) {
        super(http, Resource.EMPLOYEE_GROUPS, (obj?) => new EmployeeGroup(obj));
    }
}
